import { render, staticRenderFns } from "./Asociar.vue?vue&type=template&id=6a87bee2"
import script from "./Asociar.vue?vue&type=script&lang=js"
export * from "./Asociar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports